import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, Suspense as _Suspense, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/warabi_online.png'


const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "メニュー", -1)
const _hoisted_3 = ["id"]
const _hoisted_4 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_page_header, {
      id: _ctx.$style.header,
      icon: null
    }, {
      title: _withCtx(() => [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              id: _ctx.$style.headerLogo,
              src: _imports_0
            }, null, 8, _hoisted_1)
          ]),
          _: 1
        })
      ]),
      content: _withCtx(() => [
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.$style.pc)
        }, [
          _createVNode(_component_router_link, {
            class: _normalizeClass(_ctx.$style.header_link),
            to: "/video/search"
          }, {
            default: _withCtx(() => [
              _createTextVNode("レッスン")
            ]),
            _: 1
          }, 8, ["class"]),
          _createTextVNode("    "),
          _createElementVNode("a", {
            class: _normalizeClass(_ctx.$style.header_link),
            href: "https://waraku2009.theshop.jp"
          }, "ストア", 2)
        ], 2)
      ]),
      extra: _withCtx(() => [
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.$style.pc)
        }, [
          _createVNode(_component_router_link, {
            class: _normalizeClass(_ctx.$style.header_link),
            to: "/video/subscription"
          }, {
            default: _withCtx(() => [
              _createTextVNode("申し込み")
            ]),
            _: 1
          }, 8, ["class"]),
          _createTextVNode("    "),
          _createVNode(_component_router_link, {
            class: _normalizeClass(_ctx.$style.header_link),
            to: "/"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.state.ifLogin ? 'ログアウト' : 'ログイン'), 1)
            ]),
            _: 1
          }, 8, ["class"]),
          _createTextVNode("    ")
        ], 2),
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.$style.sp)
        }, [
          _hoisted_2,
          _createVNode(_component_el_icon, {
            onClick: _ctx.menuIconClick,
            size: "40"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Menu)
            ]),
            _: 1
          }, 8, ["onClick"])
        ], 2)
      ]),
      _: 1
    }, 8, ["id"]),
    _createVNode(_Transition, { name: "el-fade-in" }, {
      default: _withCtx(() => [
        (_ctx.state.menuOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              id: _ctx.$style.menu,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.menuClick && _ctx.menuClick(...args)))
            }, [
              _createElementVNode("p", null, [
                _createElementVNode("a", {
                  class: _normalizeClass(_ctx.$style.header_link),
                  href: "/video/search"
                }, "レッスン", 2)
              ]),
              _createElementVNode("p", null, [
                _createElementVNode("a", {
                  class: _normalizeClass(_ctx.$style.header_link),
                  href: "https://waraku2009.theshop.jp"
                }, "ストア", 2)
              ]),
              _createElementVNode("p", null, [
                _createElementVNode("a", {
                  class: _normalizeClass(_ctx.$style.header_link),
                  href: "/video/subscription"
                }, "申し込み", 2)
              ]),
              _createElementVNode("p", null, [
                _createElementVNode("a", {
                  class: _normalizeClass(_ctx.$style.header_link),
                  href: "/"
                }, _toDisplayString(_ctx.state.ifLogin ? 'ログアウト' : 'ログイン'), 3)
              ])
            ], 8, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      id: _ctx.$style.app
    }, [
      (_openBlock(), _createBlock(_Suspense, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }))
    ], 8, _hoisted_4)
  ]))
}